import { MeterPopulate } from '@enmon/commons/lib/enmon';

export const DEFAULT_USE_METER_POPULATE: MeterPopulate[] = [
  MeterPopulate.Establishment,
  MeterPopulate.Parent,
  MeterPopulate.Customer,
];
